module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "front-footer"
  }, [_c('div', {
    staticClass: "front-footer-go-up-container"
  }, [(_vm.isGoUpNeeded) ? _c('button', {
    staticClass: "go-up-button",
    attrs: {
      "title": "Go back to the top of the page"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goUpAction()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "front-footer-top"
  }, [_c('div', {
    staticClass: "myContainer"
  }, [_c('div', {
    staticClass: "front-footer-top__inner"
  }, [_c('div', {
    staticClass: "front-footer-supported-by"
  }, [(_vm.sponsors.length) ? [(_vm.sponsorsLogo) ? _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v(_vm._s(_vm.sponsorsLogo))]) : _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v("In association with")]), _vm._v(" "), _c('div', {
    staticClass: "industry-logos"
  }, [_vm._l((_vm.sponsors), function(row, index) {
    return [(row.url) ? [(index < 10) ? _c('a', {
      staticClass: "industry-logos__item",
      class: 'industry-logos__item__' + (index + 1),
      attrs: {
        "href": row.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(row.logo),
        "alt": row.altImage
      }
    })]) : _vm._e()] : [(index < 10) ? _c('a', {
      staticClass: "industry-logos__item",
      class: 'industry-logos__item__' + (index + 1),
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(row.logo),
        "alt": row.altImage
      }
    })]) : _vm._e()]]
  })], 2)] : [(this.footerData.logosLabel) ? _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v(_vm._s(this.footerData.logosLabel))]) : _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v("Sponsors")]), _vm._v(" "), _c('div', {
    staticClass: "industry-logos"
  }, [_vm._l((this.footerData.logos), function(row, index) {
    return [(row.url) ? [(index < 10) ? _c('a', {
      staticClass: "industry-logos__item",
      class: 'industry-logos__item__' + (index + 1),
      staticStyle: {
        "background-color": "transparent"
      },
      attrs: {
        "href": row.url,
        "target": "_blank",
        "title": row.alt
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(_vm.getHighImage(row)),
        "alt": row.altImage
      }
    })]) : _vm._e()] : [(index < 10) ? _c('a', {
      staticClass: "industry-logos__item",
      class: 'industry-logos__item__' + (index + 1),
      staticStyle: {
        "background-color": "transparent"
      },
      attrs: {
        "href": row.url,
        "title": row.alt
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageFullPath(_vm.getHighImage(row)),
        "alt": row.altImage
      }
    })]) : _vm._e()]]
  })], 2)]], 2), _vm._v(" "), _c('div', {
    staticClass: "front-footer-info"
  }, [(this.footerData.addressLabel) ? _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v(_vm._s(this.footerData.addressLabel))]) : _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v("Address")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(this.footerData.address)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "front-footer-social"
  }, [(this.footerData.socialLabel) ? _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v(_vm._s(this.footerData.socialLabel))]) : _c('span', {
    staticClass: "footer-section-head"
  }, [_vm._v("Join us")]), _vm._v(" "), _c('ul', {
    staticClass: "front-footer-social-list"
  }, _vm._l((this.footerData.social), function(item) {
    return _c('li', {
      staticClass: "front-footer-social-list__item"
    }, [_c('a', {
      staticClass: "front-footer-social-list__link",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(item))
      }),
      attrs: {
        "href": item.url,
        "target": "_blank",
        "title": item.altImage,
        "aria-label": item.altImage
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "front-footer-links"
  }, [_c('div', {
    staticClass: "myContainer"
  }, [_c('div', {
    staticClass: "front-footer-links__inner"
  }, [_c('ul', {
    staticClass: "front-footer-links-list"
  }, _vm._l((this.footerData.menu), function(item) {
    return _c('li', {
      staticClass: "front-footer-links-list__item"
    }, [_c('a', {
      staticClass: "front-footer-links-list__link",
      attrs: {
        "href": item.url,
        "title": item.alt
      }
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85022b8e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/common/AppFooter.vue
// module id = 975
// module chunks = 1